// Import model
import { FilterCondition } from '../models/FilterCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterCondition - handles JSON serialization and deserialization with type validation
 */
export class FilterConditionSerializer {
  /**
   * Deserializes a JSON string into a FilterCondition instance
   */
  static deserialize(json: string): FilterCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterCondition instance
   */
  static fromObject(obj: any): FilterCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterCondition');
    }


    const instance: FilterCondition = {
      fieldName: obj['FieldName'] as string,
      operator: obj['Operator'] as string,
      value: obj['Value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterCondition instances
   */
  static deserializeArray(json: string): FilterCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterCondition instance to a JSON string
   */
  static serialize(instance: FilterCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterCondition instance to a plain object
   */
  static toObject(instance: FilterCondition): any {
    return {
      'FieldName': instance.fieldName,
      'Operator': instance.operator,
      'Value': instance.value,
    };
  }

  /**
   * Serializes an array of FilterCondition instances to a JSON string
   */
  static serializeArray(instances: FilterCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
